import React from "react";
import { IconButton } from "@mui/material";
import TenantLogo from "../layout/components/TenantLogo";
import { useTranslation } from "react-i18next";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import Header from "../layout/components/Header";

const StyledCancelIcon = styled(XCircleIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

function WithEmail({ text, email }: { text: string; email: string }) {
  const parts = text.split("{email}");

  return (
    <p>
      {parts[0]}
      <a
        href={`mailto:${email}`}
        className="text-base text-primary hover:underline"
      >
        {email}
      </a>
      {parts[1]}
    </p>
  );
}

const MoreToComeContent = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { config } = useSelector((state: RootState) => state.tenantConfig);

  // Function to redirect to the root URL
  const redirectToRoot = () => {
    navigate("/"); // Redirect to the root URL
  };


  return (
    <div>
      <Header>
        <div className="size-12"></div>
        <TenantLogo />
        <IconButton onClick={redirectToRoot}>
          <StyledCancelIcon
            className="size-8 text-black-500"
            fontSize="small"
          />
        </IconButton>
      </Header>
      <h5
        style={{
          fontWeight: 600,
          fontSize: "1.5rem", // 24px
          marginTop: "2.5rem", // 40px
          marginBottom: "1.5rem", // 24px
          textAlign: "center",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
      >
        {config?.content?.[i18n.language]?.moreToCome?.header_text}
      </h5>
      <p
        style={{
          textAlign: "center",
          fontSize: "1rem", // 16px
          letterSpacing: "0.32px",
          lineHeight: "1.25rem", // 20px
          color: "gray",
          paddingLeft: "20px",
          paddingRight: "20px",
          marginBottom: "1.5rem", // 24px
        }}
      >
        {config?.content?.[i18n.language]?.moreToCome?.first_text}
      </p>
      <p
        style={{
          textAlign: "center",
          fontSize: "1rem", // 16px
          letterSpacing: "0.32px",
          lineHeight: "1.25rem", // 20px
          color: "gray",
          paddingLeft: "20px",
          paddingRight: "20px",
          marginBottom: "1.5rem", // 24px
        }}
      >
        <WithEmail
          text={config?.content?.[i18n.language]?.moreToCome?.second_text || ""}
          email={config?.email || ""}
        />
      </p>
    </div>
  );
};

export default MoreToComeContent;
